import React from 'react';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { NavigationProvider } from 'Components/ComponentLibrary/Organisms/NavigationWithContext/NavigationContext';
import Modal from './Components/Modal';

const ModalWithNavigationProvider = (props) => {
  const {
    modalResource,
    loadModalCollectionByLink,
  } = useModalContext();

  // Modal gets its own NavigationProvider in case it is needed for a Navigation
  if (modalResource) {
    return (
      <NavigationProvider loadPageLink={link => loadModalCollectionByLink(link.attr('url'))} pageResource={modalResource}>
        <Modal {...props} />
      </NavigationProvider>
    );
  }

  return null;
};

export default ModalWithNavigationProvider;
